import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { getCatalog } from '~/entities/catalog/api';
import { withGlobalSearch } from '~/entities/catalog/url-search';
import { SearchResultsPage } from '~/pages/search';

const searchSchema = withGlobalSearch({
  page: z.coerce.number().int().min(1).optional(),
});

export const Route = createFileRoute('/search')({
  validateSearch: searchSchema,
  loader: async () => getCatalog(),
  component: SearchRoute,
});

function SearchRoute() {
  const { search, page } = Route.useSearch();

  return <SearchResultsPage query={search ?? ''} page={page ?? 1} />;
}
